// Auto-generated file - do not edit manually
export const LOCALE_HASH = '7d3677d7';
